module.exports = __webpack_public_path__ + "static/media/CREDC-01.c63c3588.svg";